import React from 'react'
import Link from 'gatsby-link'

const fact1 = '/pdf/FACT SHEET 1_VIF_Indikator.pdf'
const fact2 = '/pdf/FACT SHEET 2_VIF_Kriterien.pdf'
const charta = '/pdf/Charta zur Vereinbarkeit von Familie und Beruf.pdf'

const karten = []
for (let i = 2025; i >= 2016; i--) {
  karten.push({
    title: `Karte VIF-Indikator inkl. Kooperationen ${i}/${i + 1 - 2000} (PDF)`,
    link: `/pdf/Karte_VIF_Indikator_inkl_Koop_${i}_${i + 1}.pdf`,
  })
}

const FactBox = () => (
  <div className="content-box">
    <h2>FactBox</h2>
    <h3>1. Fact Sheets</h3>
    <h4 style={{ color: '#be0021' }}>VIF-Indikator – Information</h4>
    Mithilfe des sogenannten VIF-Indikators wird in Österreich jene mit der
    Vollbeschäftigung der Eltern zu verein­barende, elementare Kinderbildung und
    -betreuung („VIF-Krite­rien“) sichtbar gemacht.{' '}
    <a target="_blank" href={fact1}>
      Fact Sheet 1
    </a>
    <h4 style={{ color: '#be0021' }}>VIF-Kriterien – Information</h4>
    <a target="_blank" href={fact2}>
      Fact Sheet 2
    </a>
    <h3>2. Dokumente</h3>
    <ul style={{ listStyle: 'none', paddingLeft: '0' }}>
      {karten.map(({ link, title }) => (
        <li>
          <a target="_blank" href={link}>
            {title}
          </a>
        </li>
      ))}
      <li>
        <a target="_blank" href={charta}>
          Charta zur Vereinbarkeit von Familie und Beruf (PDF)
        </a>
      </li>
      <li>
        <a>Broschüre Kinderbetreuungsatlas (PDF – nach Fertigstellung)</a>
      </li>
      <li>
        <a href="https://www.arbeiterkammer.at/service/studien/frauen/Wiedereinstiegsmonitoring.html">
          Wiedereinstiegsmonitoring
        </a>
      </li>
      <li>
        <a href="https://bgld.arbeiterkammer.at/service/broschuerenundratgeber/akstudien/Unter_einem_hut.html">
          Alles unter einen Hut
        </a>
      </li>
    </ul>
  </div>
)

export default FactBox



// WEBPACK FOOTER //
// ./src/pages/Fact-Box.js